import { useEffect } from 'react';

/**
 * 为当前路由页添加临时 body 类名，让页面 CSS 与 Portal 弹层共享同一作用域。
 */
export function useBodyStyleScope(scopeClassName) {
    useEffect(() => {
        document.body.classList.add(scopeClassName);

        return () => {
            document.body.classList.remove(scopeClassName);
        };
    }, [scopeClassName]);
}
